document.addEventListener('DOMContentLoaded', function () {
  const buyNowWrapper = document.getElementById('bangle-buy-now-wrapper');
  if (!buyNowWrapper) return;

  const variantSelectors = document.querySelectorAll(
    'select[name="id"], input[name="id"]'
  );

  function enableBuyNow() {
    buyNowWrapper.style.pointerEvents = 'auto';
    buyNowWrapper.style.opacity = '1';
  }

  function disableBuyNow() {
    buyNowWrapper.style.pointerEvents = 'none';
    buyNowWrapper.style.opacity = '0.5';
  }

  disableBuyNow();

  variantSelectors.forEach(el => {
    el.addEventListener('change', function () {
      if (this.value && this.value !== '') {
        enableBuyNow();
      } else {
        disableBuyNow();
      }
    });
  });
});
